import {FieldProps} from "formik";
import {IRadioButtonProps} from "../../../models/form-controls.model";
import _ from "lodash";
import {useCallback} from "react";
import RadioButtonComponent from "../radio-button/radioButton";

interface FormikRadioButtonComponentProps extends IRadioButtonProps {
    formikField: FieldProps;
}

const FormikRadioButtonComponent = (props: FormikRadioButtonComponentProps) => {
    const {
        formikField,
        onChange,
        option,
        ...otherProps
    } = props;
    const {form, field} = formikField;
    const {name, value} = field;
    const {setFieldTouched, touched, errors, setFieldValue} = form;
    const hasError = _.get(touched, name) && !!(_.get(errors, name));

    const defaultDisplayWith = useCallback((item: any) => item?.title || '', []);
    const defaultValueExtractor = useCallback((item: any) => item?.code, []);
    const defaultKeyExtractor = useCallback((item: any) => item?._id, []);
    const displayWith = props.displayWith || defaultDisplayWith;
    const valueExtractor = props.valueExtractor || defaultValueExtractor;
    const keyExtractor = props.keyExtractor || defaultKeyExtractor;
    otherProps.id = otherProps.id || name;

    const onValueChange = useCallback((value: any) => {
        setFieldTouched(name);
        setFieldValue(name, value);
        if (onChange) {
            onChange(value)
        }
    }, [setFieldValue, setFieldTouched, onChange, name])


    return (
        <RadioButtonComponent
            key={keyExtractor(option)}
            value={valueExtractor(option)}
            checked={valueExtractor(option) === value}
            label={displayWith(option)}
            name={name}
            onChange={(value: any) => {
                console.log(value)
                onValueChange(value);
            }}
            hasError={hasError}
            errorMessage={hasError && _.get(errors, name)}
            {...otherProps}
        />
    );

};

export default FormikRadioButtonComponent;